module.exports = __webpack_public_path__ + "static/img/partner-mxld.b9e6aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-mxld.png
// module id = 5Joi
// module chunks = 34